import {makeAutoObservable} from 'mobx';
import MicrolessonsRepository from '../../../data/repositories/MicrolessonsRepository';
import LoadingModule from '../../LoadingModule/LoadingModule';
import {toast} from 'react-toastify';
import {microlessonsLibraryText} from '../microlessonsLibraryText';
import {toastConfig} from '../../../uiToolkit/Toast/toastConfig';
import {getErrorFromCode} from '../../../data/errorCodes';

class MicrolessonsLibraryStore {
  private microlessonsRepo = new MicrolessonsRepository();

  private isOpen = false;
  private isGradable = false;
  private loadingModule = new LoadingModule();
  private onFinishCallback?: () => void;

  constructor() {
    makeAutoObservable(this);
  }

  public get isLoading() {
    return this.loadingModule.isLoading;
  }

  public get showLibrary() {
    return this.isOpen;
  }

  public openLibrary(isGradable: boolean, onFinishCallback?: () => void) {
    this.isOpen = true;
    this.isGradable = isGradable;
    this.onFinishCallback = onFinishCallback;
  }

  public closeLibrary() {
    this.isOpen = false;
    this.onFinishCallback = undefined;
  }

  public async getMicrolessonsLibrary(
    organizationId: string,
    page: number,
    pageSize: number,
    search?: string,
  ) {
    const result = await this.microlessonsRepo.getMicrolessonsLibrary(
      organizationId,
      page,
      pageSize,
      this.isGradable ? undefined : false,
      search,
    );
    if (result.success && result.data) {
      return result.data;
    }
    return {
      pagesCount: 0,
      data: [],
    };
  }

  public async copyMicrolessonToCourse(
    organizationId: string,
    courseId: string,
    folderId: string,
    microlessonId: string,
  ) {
    this.loadingModule.startLoading();
    const result = await this.microlessonsRepo.copyMicrolessonToCourse(
      organizationId,
      courseId,
      folderId,
      microlessonId,
    );
    this.loadingModule.endLoading();
    if (result.success) {
      toast.success(microlessonsLibraryText.lessonCopied, toastConfig);
      if (this.onFinishCallback) {
        this.onFinishCallback();
        this.closeLibrary();
      }
    } else if (result.errors && result.errors.length) {
      toast.error(getErrorFromCode(result.errors[0]));
    }
  }
}

export default MicrolessonsLibraryStore;
